import React from "react";
import Section11A1 from "./Section11A1";
import Section11A2 from "./Section11A2";
import { useMediaQuery, Box } from "@mui/material";

const Section11A = ({data, index}) => {
  // Breakpoints
  const isMobileOrLaptop = useMediaQuery("(max-width: 1200px)"); // Show for xs, sm, md, lg
  const isXLScreen = useMediaQuery("(min-width: 1201px)"); // Show for xl only

  return (
    <Box>
      {/* Section11A1 for Mobile and Laptop */}
      {isMobileOrLaptop && <Section11A1 data={data} index={index}/>}

      {/* Section11A2 for XL Screens */}
      {isXLScreen && <Section11A2 data={data} index={index}/>}
    </Box>
  );
};

export default Section11A;
